<template>
  <div class="d-flex" id="wrapper">
    <Sidebar :toggler.sync="isToggled" />
    <!-- Page Content -->

    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getManagerUserProfile" />

      <div v-if="isMainLoading" class="container-fluid mobile-settings">
        <div class="col-md-12">
          <div class="card card-custom" style="height: 85vh !important;">
            <Spinner :isLoading="isMainLoading" />
          </div>
        </div>
      </div>

      <div v-else class="container-fluid mobile-settings">
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">
            <div class="card card-custom">
              <div class="graphs-container">
                <ChartOne />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div id="cardu" class="card card-custom">
              <div class="graphs-container">
                <div ref="funnel1" id="funnel-chart1">
                  <FunnelOne />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row hide-on-mobile">
          <div class="col-md-12">
            <div class="card" style="margin: 0 0 30px 0">
              <h6 class="p-2" style="font-weight: 700">Recent Placements</h6>
              <Spinner :isLoading="isLoading" />
              <div class="table-responsive">
                <table class="table table-striped custom-table ">
                  <thead class="bg-dark">
                    <tr>
                      <th nowrap scope="col">NAME</th>
                      <th nowrap scope="col">JOB</th>
                      <th nowrap scope="col">LOCATION</th>
                      <th nowrap cpope="col">HIRED</th>
                    </tr>
                  </thead>

                  <tbody>
                    <ManagerDashboardRecentPlacementsTableItem
                      v-for="(rPlacement, i) in getManagerRecentPlacements"
                      :recentPlacement="rPlacement"
                      :key="i"
                    />
                  </tbody>
                </table>
              </div>

              <ErrorList
                class="no-data-message mt-5"
                v-show="getManagerRecentPlacements.length === 0"
                name="noRecentPlacements"
              />

              <div class="bottom-controls ml-auto mt-auto w-10">
                <div id="pagination" class="desktop-only">
                  <Pagination
                    :currentPage="getCurrentPage"
                    :totalPages="getTotalPages"
                    @nextPage="nextPage"
                    @prevPage="previousPage"
                    @keyup="keymonitor"
                    @selectPageByNumber="setPageBynumber"
                    @firstPage="setToFirstPage"
                    @lastPage="setToLastPage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div @scroll="onScroll" class="row mobile-interface">
          <div class="col-md-12">
            <h4>Recent Placements</h4>

            <ul class="list-unstyled">
              <li v-for="(rPlacement, i) in lazyLoad" :key="i">
                <div class="header">
                  <router-link
                    class="bold"
                    style="text-decoration: none"
                    :to="{
                      name: 'manager_candidate_id',
                      params: { manager_candidate_id: rPlacement.candidate_id },
                    }"
                  >
                    {{ rPlacement.candidate_name }}
                  </router-link>
                  <div class="location">
                    {{
                      rPlacement.hired_date
                        | formatDate({
                          format: getManagerUserProfile.format_date,
                          timezone: getManagerUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </div>
                </div>
                <div class="header">
                  <div>
                    <router-link
                      class="small"
                      style="text-decoration: none"
                      :to="{
                        name: 'manager_job_uuid',
                        params: { manager_job_uuid: rPlacement.job_id },
                      }"
                      >{{ rPlacement.job }}</router-link
                    >
                    <div class="location">
                      {{ rPlacement.location.city }}, {{ rPlacement.location.country }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Welcome Modal -->
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Welcome to JobShark</h5>
            </div>
            <div class="modal-body">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </div>
            <div class="modal-footer d-flex justify-content-center">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Continue</button>
              <button type="button" class="btn btn-primary" data-dismiss="modal">Skip Tour</button>
            </div>
          </div>
        </div>
      </div>
      <!-- End Welcome Modal -->
    </div>
    <!-- End page-content-wrapper -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Sidebar from '@/components/Navigations/ManagerSidebar';
import TopNavbar from '@/components/Navigations/TopNavbar';
/* import FunnelDiagram from '@/components/Admin/Dashboard/FunnelDiagram'; */
import ManagerDashboardRecentPlacementsTableItem from '../../components/Manager/Dashboard/ManagerDashboardRecentPlacementsTableItem';
import { toggleSidebarNav } from '../../mixins/toggleSidebarNav';
import Pagination from '@/components/Navigations/Pagination';
import ErrorList from '@/components/common/errorsList';

import ChartOne from '@/components/Manager/Dashboard/LineChart/ChartOne';
import FunnelOne from '@/components/Manager/Dashboard/FunnelChart/FunnelOne';
/* import axios from 'axios'; */
import format from 'date-fns/format';
import moment from 'moment';
import titleMixin from '../../mixins/titleMixin';
// import { errorService } from '../../services/errorService';

export default {
  components: {
    Sidebar,
    TopNavbar,
    ChartOne,
    FunnelOne,
    Pagination,
    ErrorList,
    ManagerDashboardRecentPlacementsTableItem,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return 'Dashboard | Jobshark';
  },
  data: () => ({
    listOfSelectedJobs: [],

    elWidth: null,
    filterCurrentSelection: 'All time',
    isToggled: false,
    isLoading: false,
    isMainLoading: true,
    dateFormat: 'D MMM YYYY',
    startDate: '',
    endDate: '',
    currentPage: 1,
    pageCount: 10,
    lazyLoad: [],
  }),
  methods: {
    ...mapActions('managerStoreModule', [
      'retrieveManagerRecentPlacements',
      'retrieveManagerProfile',
      'retrieveManagerJobsDropdown',
      'retrieveManagerUserProfile',
    ]),
    onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.currentPage++;
        this.retrieveManagerRecentPlacements({
          page: this.currentPage,
          count: this.pageCount,
        }).then(() => {
          const recentPlacements = Object.values(this.getManagerRecentPlacements);
          this.lazyLoad = [...this.lazyLoad, ...recentPlacements];
        });
      }
    },
    keymonitor(event) {
      // who caused it? "event.target.id"
      // console.log('keyup from id: ' + event.target.id);

      // what was pressed?
      let keyMessage = event.key || String.fromCharCode(event.keyCode);

      /* if (event.shiftKey) {
        keyMessage += 'Shift+';
      } */

      if (keyMessage == 'ArrowRight') {
        this.nextPage();
      }

      if (keyMessage == 'ArrowLeft') {
        this.previousPage();
      }
    },

    lastSevenDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(7, 'days')
        .format('DD MMM YYYY')}`;
    },
    lastThirtyDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(30, 'days')
        .format('DD MMM YYYY')}`;
    },
    lastNinetyDays() {
      return `${moment().format('DD MMM YYYY')} - ${moment()
        .add(90, 'days')
        .format('DD MMM YYYY')}`;
    },
    handleFilter(e) {
      if (e.target.innerText === 'Last 7 days') {
        this.filterCurrentSelection = this.lastSevenDays();
      }

      if (e.target.innerText === 'Last 30 days') {
        this.filterCurrentSelection = this.lastThirtyDays();
      }

      if (e.target.innerText === 'Last 90 days') {
        this.filterCurrentSelection = this.lastNinetyDays();
      }

      if (e.target.innerText === 'All time') {
        this.filterCurrentSelection = 'All time';
      }
    },
    formatDates(startDate, endDate) {
      /*  if (startDate) {
        formattedDates = format(startDate, this.dateFormat);
      }

      if (endDate) {
        formattedDates += ' - ' + format(endDate, this.dateFormat);
      } */

      if (startDate && endDate) {
        return `${format(startDate, this.dateFormat)} - ${format(endDate, this.dateFormat)}`;
      }
    },

    /* PAGINATION */
    nextPage() {
      if (this.currentPage >= 1 && this.currentPage < this.getTotalPages) {
        this.isLoading = true;
        this.currentPage++;

        this.retrieveManagerRecentPlacements({
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.isLoading = true;
        --this.currentPage;

        this.retrieveManagerRecentPlacements({
          page: this.currentPage,
          count: this.pageCount,
        })
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else {
        this.currentPage = 1;
      }
    },
    setToFirstPage() {
      this.isLoading = true;
      this.currentPage = 1;

      this.retrieveManagerRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setToLastPage(lastPage) {
      this.isLoading = true;
      this.currentPage = lastPage;

      this.retrieveManagerRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setPageBynumber(pageNumber) {
      if (pageNumber > this.getTotalPages || pageNumber < 1) return;
      this.currentPage = pageNumber;

      this.retrieveManagerRecentPlacements({
        page: this.currentPage,
        count: this.pageCount,
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    /* END PAGINATION */
  },
  computed: {
    ...mapGetters('managerStoreModule', [
      'getManagerRecentPlacements',
      'getManagerProfile',
      'getCurrentPage',
      'getTotalPages',
      'getNextPage',
      'getManagerUserProfile',
    ]),
    myStyles() {
      return {
        height: `${100}%`,
        width: `${100}%`,
        position: 'absolute',
      };
    },
  },

  mounted() {
    this.retrieveManagerRecentPlacements({
      page: 1,
      count: 10,
    }).then(() => {
      this.lazyLoad = this.getManagerRecentPlacements;
    });

    this.retrieveManagerUserProfile();
    this.retrieveManagerJobsDropdown().then(() => {
      this.isMainLoading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.mobile-interface {
  display: none;
}
.custom-table {
  th {
    border-bottom: none !important;
  }
}
.graphs-container {
  display: flex;
  position: relative;
  flex: 1;
}

#funnel-chart1,
#funnel-chart2 {
  display: flex;
  flex: 1;
}

.graphs,
#wrapper {
  overflow: hidden;
  .card-custom {
    display: flex;
    margin: 0 0 30px 0 !important;
    height: 420px;
  }
  .row {
    padding-left: 9px;
    padding-right: 9px;
  }
}

.svg-funnel-js {
}
.svg-funnel-js__subLabels {
  margin-top: 200px !important;
}
.graphs {
  font-family: $font-family-sans-lato !important;
}

/deep/ .svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__title {
  font-size: 13px;
  font-weight: normal;
  color: #333;
  /*   background: #e65023; */
  font-family: $font-family-sans-lato !important;
}

/deep/ .svg-funnel-js .svg-funnel-js__labels .svg-funnel-js__label .label__value {
  font-size: 13px;

  line-height: 18px;
  margin-bottom: 6px;
  color: #333;
}

/deep/ .svg-funnel-js .svg-funnel-js__subLabels .svg-funnel-js__subLabel {
  color: #333;
}

.svg-funnel-js {
  flex: 1 !important;
}

.svg-funnel-js .svg-funnel-js__container {
  width: 100%;
  height: 100%;
}

.mobile-lists {
  display: none;
}

/* .dropdown-toggle {
  width: 100%;
  text-align: left;
  color: #495057;
  &:after {
    position: absolute;
    right: 8px;
    top: 18px;
  }
} */

.dashboard-filters {
  padding: 20px 6px 22px 6px;
  .form-group {
    margin-bottom: 0;
    .form-control {
      font-family: $font-family-sans-lato;
      font-size: 0.9375rem;
    }
  }
  .dropdown-toggle {
    font-family: $font-family-sans-lato;
    font-size: 0.9375rem;
  }
}

.dashboard-filters.funnel {
  padding-bottom: 20px;
}

.modal-dialog-centered {
  .modal-header {
    padding-bottom: 0;
    .modal-title {
      display: block;
      width: 100%;
      text-align: center;
    }
  }
  .modal-body {
    font-size: 14px;
    text-align: center;
  }
}

@media only screen and (max-width: 576px) {
  .mobile-settings {
    padding-left: 0;
    padding-right: 0;
    .row {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  .mobile-settings {
    margin-top: 30px;
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

@media only screen and (max-width: 992px) {
  .custom-table {
    th {
      width: 240px;
    }
  }
}

@media only screen and (max-width: 1250px) {
  .mobile-settings {
    margin-top: 30px;
    .col-md-6 {
      width: 100% !important;
      min-width: 100% !important;
    }
    .card {
      border-radius: 0 !important;
    }
    .card-custom {
      height: 420px !important;
      min-height: 420px !important;
    }
  }
}

/* @media only screen and (min-width: 1900px) {
  .graphs-container {
    position: relative;
  }

  .graphs,
  #wrapper {
    overflow: hidden;
    .card-custom {
      margin: 0 0 30px 0 !important;
      height: 520px;
    }
    .row {
      padding-left: 9px;
      padding-right: 9px;
    }
  }
  #funnel-chart {
    width: 100%;
  }
  .svg-funnel-js {
    padding-top: 160px;
    width: 100%;
  }
}

@media only screen and (max-width: 1251px) {
  #wrapper {
    .card {
      border-radius: 8px !important;
    }
    .card-custom {
      margin: 30px 0 0 0 !important;
    }
  }
}

@media only screen and (max-width: 992px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 25px 0 0 0 !important;
      overflow: hidden;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    width: 100%;
    max-width: 100%;
    flex: 100%;
    padding: 0;
    .card {
      border-radius: 0 !important;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      margin-bottom: 0;
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
  .hide-on-mobile {
    display: none !important;
  }
}

@media only screen and (max-width: 768px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 25px 0 0 0 !important;
      overflow: hidden;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    padding: 0;
    .card {
      border-radius: 0 !important;
      height: auto !important;
      min-height: auto !important;
    }
  }
  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      margin-bottom: 0;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
  .hide-on-mobile {
    display: none !important;
  }
}

@media only screen and (max-width: 576px) {
  #wrapper {
    .row {
      padding-left: 0;
      padding-right: 0;
    }
    .form-group {
      padding: 0 !important;
      padding-left: 30px !important;
      padding-right: 30px !important;
      margin-bottom: 12px;
    }
    .card-custom {
      margin: 0 0 20px 0 !important;
      border-radius: 0 !important;
    }
  }
  .col-md-6,
  .col-md-12 {
    padding: 0;
    .card {
      border-radius: 0 !important;
    }
  }

  .hide-on-mobile {
    display: none !important;
  }

  .mobile-lists {
    h6 {
      background: #fff;
      margin: 20px 0 0 0;
      padding: 12px 15px 0px 15px;
      font-size: 1.2rem;
    }
    display: block;
    width: 100%;
    .list-unstyled {
      font-family: $font-family-sans-lato;
      background: #fff;
      li {
        position: relative;
        border-bottom: 1px solid #ddd;
        padding: 9px 15px 15px 15px;
        .user {
          display: block;
          font-size: 16px;
          font-weight: 700;
          margin-bottom: 4px;
          text-decoration: none;
        }
        .company {
          color: #333;
          text-decoration: none;
          font-weight: 600;
          font-size: 16px;
        }
        .location,
        .job-position,
        .date,
        .rec {
          font-size: 14px;
        }
        .location {
          color: $color-orange;
        }
        .job-position {
          color: #666;
        }
        .logs {
          text-transform: uppercase;
          font-size: 12px;
          margin-right: 12px;
          font-weight: 600;
          color: #666;
        }
      }
    }
  }
} */

@media only screen and (max-width: 576px) {
  .mobile-interface {
    display: block;
    background-color: #fff;
    padding-top: 12px;
    height: 60vh;
    overflow-y: auto;
    h4 {
      margin: 12px 0 0 18px;
      font-weight: 700;
      font-size: 1rem;
    }
    .list-unstyled {
      background-color: #fff;
      li {
        padding: 18px;
        border-bottom: 3px solid #e9e9e9;
        font-family: Lato, Roboto, 'Helvetica Neue', Arial, sans-serif;
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .bold {
            font-weight: 600;
          }
          .small {
            font-size: 14px;
            color: #333;
          }
          .location {
            font-size: 14px;
          }
        }
      }
    }
  }
  .hide-on-mobile {
    display: none;
  }
}
</style>
